import { i18n } from '@/plugins/i18n'

export const shRequestStatus = {
    FINAL_REJECT:5,
    PENDING:8,
    DELAY:12,
    CONFIRMED:14,
    FINISHED:20,
    CREATED:0,
}

export const shRequestStatusStr = {
    FINAL_REJECT:i18n.t('sh_request_status.final_reject'),
    PENDING:i18n.t('sh_request_status.pending'),
    CREATED:i18n.t('sh_request_status.created'),
    DELAY:i18n.t('sh_request_status.delay'),
    CONFIRMED:i18n.t('sh_request_status.confirmed'),
    FINISHED:i18n.t('sh_request_status.finished'),
    get(status) {
        let status_str = null;
        Object.keys(shRequestStatus).forEach(function (item) {
            if(shRequestStatus[item] === status) {
                status_str = shRequestStatusStr[item]
            }
        })

        return status_str
    }
}

export const shRequestVariant = (status) => {
    if(status === shRequestStatus.CONFIRMED)
        return 'success'

    if(status === shRequestStatus.FINAL_REJECT)
        return 'danger'

    if(status === shRequestStatus.PENDING || status === shRequestStatus.DELAY)
        return 'warning'

    return 'info'
}